import { render, staticRenderFns } from "./SchoolEvents.vue?vue&type=template&id=796711e2&scoped=true&"
import script from "./SchoolEvents.vue?vue&type=script&lang=ts&"
export * from "./SchoolEvents.vue?vue&type=script&lang=ts&"
import style0 from "./SchoolEvents.vue?vue&type=style&index=0&id=796711e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796711e2",
  null
  
)

export default component.exports